import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-init",
  "use": "icon-init-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-init\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 963.765a451.765 451.765 0 1 1 0-903.53 451.765 451.765 0 0 1 0 903.53z m0-56.47a395.294 395.294 0 1 0 0-790.59 395.294 395.294 0 0 0 0 790.59z\" fill=\"#8A8A8A\" p-id=\"2673\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol